import { createAsyncThunk } from "@reduxjs/toolkit";
import productsService from "../../../api/services/products";

// Categories async thunks
export const getCategories = createAsyncThunk(
  "products/get-categories",
  async () => {
    return await productsService.getCategories();
  }
);

export const getFeaturedCategories = createAsyncThunk(
  "products/get-featured-categories",
  async () => {
    return await productsService.getFeaturedCategories();
  }
);

export const createCategory = createAsyncThunk(
  "products/create-category",
  async (requestData) => {
    return await productsService.createCategory(requestData);
  }
);

export const deleteCategory = createAsyncThunk(
  "products/delete-category",
  async (id) => {
    return await productsService.deleteCategory(id);
  }
);

export const toggleCategoryStatus = createAsyncThunk(
  "products/toggle-category-status",
  async (id) => {
    return await productsService.toggleCategoryStatus(id);
  }
);

export const editCategory = createAsyncThunk(
  "products/edit-category",
  async ({ id, requestData }) => {
    return await productsService.editCategory(id, requestData);
  }
);

// Products async thunks
export const getProducts = createAsyncThunk(
  "products/get-products",
  async (params) => {
    return await productsService.getProducts(params);
  }
);

export const getFeaturedProducts = createAsyncThunk(
  "products/get-featured-products",
  async () => {
    return await productsService.getFeaturedProducts();
  }
);

export const getProduct = createAsyncThunk(
  "products/get-product",
  async (id) => {
    return await productsService.getProduct(id);
  }
);

export const createProduct = createAsyncThunk(
  "products/create-product",
  async (formData) => {
    return await productsService.createProduct(formData);
  }
);

export const editProduct = createAsyncThunk(
  "products/edit-product",
  async ({ id, requestData }) => {
    return await productsService.editProduct(id, requestData);
  }
);

export const deleteProduct = createAsyncThunk(
  "products/delete-product",
  async (id) => {
    return await productsService.deleteProduct(id);
  }
);

export const getLowStockProducts = createAsyncThunk(
  "products/get-low-stock-products",
  async () => {
    return await productsService.getLowStockProducts();
  }
);

export const getSimilarProducts = createAsyncThunk(
  "products/get-similar-products",
  async (productId) => {
    return await productsService.getSimilarProducts(productId);
  }
);

// Product Dimensions async thunks
export const getProductDimensions = createAsyncThunk(
  "products/get-product-dimensions",
  async (productId) => {
    return await productsService.getProductDimensions(productId);
  }
);

export const saveProductDimensions = createAsyncThunk(
  "products/save-product-dimensions",
  async ({ productId, dimensionsData }) => {
    return await productsService.saveProductDimensions(productId, dimensionsData);
  }
);

export const deleteProductDimensions = createAsyncThunk(
  "products/delete-product-dimensions",
  async (productId) => {
    return await productsService.deleteProductDimensions(productId);
  }
);
